export default __webpack_public_path__ + "static/media/logo_pck.cc0e6e71.png";